import api from 'src/client/axiosInstance';

export const getEzeeAssistToken = async (): Promise<{ enabled: boolean; token?: string }> => {
  const response = await api.get('ezee-assist/token');
  return response.data;
};
